import React from 'react';
import FacturesPage from '../components/FacturesPage';
import * as api from '../api';

export default function FacturesLocation() {
  return (
    <FacturesPage
      title="Factures Location"
      fetchFn={api.getAllFacturesLocation}
      getPdfFn={api.getFactureLocationPdf}
      getDocumentOrigine={f => ({
        label: f.contrat_numero || f.contrat_id || '—',
        href:  f.contrat_id ? `/contrats?contrat_id=${f.contrat_id}` : null,
      })}
    />
  );
}
